const state = {
  unpaidFee: null,
  debitCount: null,
  extraPrincipal: null,
  initEffectiveDate: null,
  payFixAmount: null,
  maxFinanceCharge: null,
  limitFinanceCharge: null
}

// getters
const getters = {
  getMultiPayOffUnpaidFee: (state) => {
    return state.unpaidFee
  },
  getMultiPayOffInNDebitCount: (state) => {
    return state.debitCount
  },
  getMultiPayOffInNMaxFinanceCharge: (state) => {
    return state.maxFinanceCharge
  },
  getMultiPayOffInNLimitFinanceCharge: (state) => {
    return state.limitFinanceCharge
  },
  getMultiPayDownExtraPrincipal: (state) => {
    return state.extraPrincipal
  },
  getInitEffectiveDate: (state) => {
    return state.initEffectiveDate
  },
  getMultiPayFixAmount: (state) => {
    return state.payFixAmount
  }
}

// actions
const actions = {
}

// mutations
const mutations = {
  setMultiPayOffUnpaidFee (state, payload) {
    state.unpaidFee = payload
  },
  setMultiPayOffInNDebitCount (state, payload) {
    state.debitCount = payload
  },
  setMultiPayOffInNMaxFinanceCharge (state, payload) {
    state.maxFinanceCharge = payload
  },
  setMultiPayOffInNLimitFinanceCharge (state, payload) {
    state.limitFinanceCharge = payload
  },
  setMultiPayDownExtraPrincipal (state, payload) {
    state.extraPrincipal = payload
  },
  setInitEffectiveDate (state, payload) {
    state.initEffectiveDate = payload
  },
  setMultiPayFixAmount (state, payload) {
    state.payFixAmount = payload
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
